import { PcmpProjectListTable } from '../components/PcmpProjectListTable';

export function PcmpProjectsListPage() {
  return <PcmpProjectListTable />;
}
